"use client";
import { useRouter, useSearchParams } from "next/navigation";
import { Formik, Form } from "formik";
import YupNative from "@/components/layout/form/yup";
import clsx from "clsx";
import { etherealChains } from "./chains";
import { FormikSelect } from "@form/formik/FormikSelect";
import FormikInput from "@form/formik/FormikInput";
import { Button } from "@/components/layout/button/button";
import CollectionCard from "./CollectionCard";
import styles from "./ethereals.module.scss";

export const EtherealPageContent = () => {
  const params = useSearchParams();
  const token = {
    address: params!.get("address"),
    chainId: Number(params!.get("chainId") || 1),
  };
  const router = useRouter();

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <Formik
          initialValues={{ chainId: token.chainId, address: token.address }}
          onSubmit={(vals) =>
            router.push(`?chainId=${vals.chainId}&address=${vals.address}`)
          }
          enableReinitialize
          validationSchema={YupNative.object().shape({
            chainId: YupNative.number().required("Chain is required"),
            address: YupNative.string()
              .isAddress()
              .required("Address is required"),
          })}
        >
          {({ isValid }) => (
            <Form>
              <div className={clsx(styles.formGroup, "form-group")}>
                <FormikSelect
                  name="chainId"
                  label="Chain"
                  placeholder="Select a chain"
                  // TODO: allow testnets tokens?
                  options={etherealChains.map((chain) => ({
                    value: chain.id,
                    label: `${chain.name} ${
                      chain.id !== 1 ? "(coming soon)" : ""
                    }`,
                    // the service currently only supports mainnet
                    // disabled: chain.id !== 1,
                  }))}
                />

                <FormikInput
                  label="Contract Address"
                  name="address"
                  placeholder="0x..."
                />
                <div>
                  {/* hack to align button with inputs */}
                  <div
                    style={{
                      marginTop: "0.5rem",
                      marginBottom: "0.25rem",
                    }}
                  >
                    &nbsp;
                  </div>
                  <Button type="submit" size="small" disabled={!isValid}>
                    Go
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
        {token.address && (
          <div className={styles.resultContainer}>
            <CollectionCard
              chainId={token.chainId}
              contractAddress={token.address}
            />
          </div>
        )}
      </div>
    </div>
  );
};
